/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const deliveryKindSettingsSchema = z.object({
	is_available: z.boolean(),
	duration_minutes: z.int().nullable(),
});
